import { Action } from '@ngrx/store';
import { Plan, PropertyComponentGroup } from '../../plans/shared/models';
import { label } from '../../../shared/redux';
import { SetupFiscalYearRequest } from '../shared/models';

const working = '[setup]';
export const setupTypes = {

  // Anticipated Expenditures
  LOAD_ANTICIPATED_EXPENDITURES: label(working + 'load-anticipated-expenditures'),
  LOAD_ANTICIPATED_EXPENDITURES_SUCCESS: label(working + 'load-anticipated-expenditures-success'),
  LOAD_ANTICIPATED_EXPENDITURES_FAILS: label(working + 'load-anticipated-expenditures-fails'),

  // Age Plan Components
  SETUP_FISCAL_YEAR: label(working + 'setup-fiscal-year'),
  SETUP_FISCAL_YEAR_SUCCESS: label(working + 'setup-fiscal-year-success'),
  SETUP_FISCAL_YEAR_FAILS: label(working + 'setup-fiscal-year-fails'),

  SKIP_FISCAL_YEAR_SETUP: label(working + 'skip-fiscal-year-setup'),
  SKIP_FISCAL_YEAR_SETUP_SUCCESS: label(working + 'skip-fiscal-year-setup-success'),
  SKIP_FISCAL_YEAR_SETUP_FAILS: label(working + 'skip-fiscal-year-setup-fails'),
};


/* Anticipated Expenditures */
export class LoadAnticipatedExpendituresAction implements Action {
  readonly type = setupTypes.LOAD_ANTICIPATED_EXPENDITURES;
  constructor(public payload: { propertyId: string, fiscalYear: number }) { }
}

export class LoadAnticipatedExpendituresSuccessAction implements Action {
  readonly type = setupTypes.LOAD_ANTICIPATED_EXPENDITURES_SUCCESS;
  constructor(public payload: PropertyComponentGroup) { }
}

export class LoadAnticipatedExpendituresFailsAction implements Action {
  readonly type = setupTypes.LOAD_ANTICIPATED_EXPENDITURES_FAILS;
  constructor(public payload: any) { }
}

/* Aging */

export class SetupFiscalYearAction implements Action {
  readonly type = setupTypes.SETUP_FISCAL_YEAR;
  constructor(public payload: SetupFiscalYearRequest) { }
}

export class SetupFiscalYearSuccessAction implements Action {
  readonly type = setupTypes.SETUP_FISCAL_YEAR_SUCCESS;
  constructor(public payload: any) { }
}

export class SetupFiscalYearFailsAction implements Action {
  readonly type = setupTypes.SETUP_FISCAL_YEAR_FAILS;
  constructor(public payload: any) { }
}

export class SkipFiscalYearSetupAction implements Action {
  readonly type = setupTypes.SKIP_FISCAL_YEAR_SETUP;
  constructor(public payload: { propertyId: string, fiscalYear: number, informationSourceId: number }) { }
}

export class SkipFiscalYearSetupSuccessAction implements Action {
  readonly type = setupTypes.SKIP_FISCAL_YEAR_SETUP_SUCCESS;
  constructor(public payload: Plan) { }
}

export class SkipFiscalYearSetupFailsAction implements Action {
  readonly type = setupTypes.SKIP_FISCAL_YEAR_SETUP_FAILS;
  constructor(public payload: any) { }
}

export type Actions =
    | LoadAnticipatedExpendituresAction
    | LoadAnticipatedExpendituresSuccessAction
    | LoadAnticipatedExpendituresFailsAction
    | SetupFiscalYearAction
    | SetupFiscalYearSuccessAction
    | SetupFiscalYearFailsAction
    | SkipFiscalYearSetupAction
    | SkipFiscalYearSetupSuccessAction
    | SkipFiscalYearSetupFailsAction
    ;
